import { render, staticRenderFns } from "./SingleUpdate.vue?vue&type=template&id=24239a41&scoped=true&"
import script from "./SingleUpdate.vue?vue&type=script&lang=js&"
export * from "./SingleUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24239a41",
  null
  
)

export default component.exports